import { useAtomCallback } from 'jotai/utils';
import { useCallback, useEffect } from 'react';

import { TrackingEvents, sendLoggingEvents } from '../events';
import { localVideoContextAtom, useStartVideo } from '../video-sdk';

export const useResetLocalVideoOnScreenOrientationChange = () => {
  const startVideo = useStartVideo();
  const getLocalVideoDelegator = useAtomCallback(useCallback((get) => get(localVideoContextAtom).delegator, []));

  useEffect(
    function handleOrientationChange() {
      const abortController = new AbortController();
      const republishTrack = async () => {
        const localVideoDelegator = getLocalVideoDelegator();
        sendLoggingEvents(TrackingEvents.DEVICE_ORIENTATION_CHANGE, {
          hasLocalVideoDelegator: !!localVideoDelegator,
          windowOrientation: window.orientation,
          screenOrientation: screen?.orientation?.type,
        });
        if (!localVideoDelegator?.isEnabled) return;
        startVideo();
      };
      window.addEventListener('orientationchange', republishTrack, {
        signal: abortController.signal,
      });
      return () => abortController.abort();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
